import React from 'react';
import PropTypes from 'prop-types';

import css from './IconDashboard.module.css';

const IconDashboard = props => {
  const { selected } = props;

  return (
    <svg
      className={selected ? css.iconSelected : css.icon}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 18H2C0.9 18 0 17.1 0 16V2C0 0.9 0.9 0 2 0H8V18ZM10 18H16C17.1 18 18 17.1 18 16V9H10V18ZM18 7V2C18 0.9 17.1 0 16 0H10V7H18Z" />
    </svg>
  );
};

const { string } = PropTypes;



IconDashboard.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconDashboard;
